import axios from "axios";

const URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002'; // Fallback to localhost if not set
// User API functions
export async function createTask(task) {
  const response = await axios.post(`${URL}/tasks`, task);
    return response;
}

// Support request API functions
export async function createSupportRequest({ description, priority, pageUrl, screenshot }) {
  const form = new FormData();
  form.append("description", description);
  form.append("priority", priority);
  form.append("pageUrl", pageUrl);
  form.append("userAgent", navigator.userAgent);
  if (screenshot) form.append("screenshot", screenshot, "screenshot.png");

  const token =
    sessionStorage.getItem("userToken") || sessionStorage.getItem("user");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const { data } = await axios.post(`${URL}/support-requests`, form, {
    headers,
  });
  return data;
}

export async function getSupportRequests() {
  const token =
    sessionStorage.getItem("userToken") || sessionStorage.getItem("user");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const { data } = await axios.get(`${URL}/support-requests`, { headers });
  return data;
}

